export const parseRestaurantId = (restaurantId: string | undefined): number | undefined => {
    const parsed = parseInt(restaurantId ?? '', 10);
    return Number.isNaN(parsed) ? undefined : parsed;
};

// get value with case insensitive key
export const getValueFromQueryString = (queryString: string, key: string) =>
    new URLSearchParams(queryString?.toLowerCase()).get(key.toLowerCase());
